module.exports = __webpack_public_path__ + "img/dog.c3eef330.png";